export interface SalesOrderLineStatusItem {
  id: string;
  orderLineStatus: string;
  user: string;
  processedDate: Date;
}
